import { useNavigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { ArrowLeft, Home, Map, CalendarDays, Trophy, Activity } from 'lucide-react';
import styles from './MoveFooter.module.css';

type Tab = {
  key: string;
  label: string;
  match: (path: string) => boolean;
  to: string;
  icon: ReactNode;
  back?: boolean;
};

const tabs: Tab[] = [
  { key: 'home',    label: 'Inicio',   match: (p) => p === '/move' || p === '/move/profile',                             to: '/move',          icon: <Home size={20} /> },
  { key: 'routes',  label: 'Rutas',    match: (p) => p.startsWith('/move/routes'),                                        to: '/move/routes',   icon: <Map size={20} /> },
  { key: 'events',  label: 'Eventos',  match: (p) => p.startsWith('/move/events'),                                        to: '/move/events',   icon: <CalendarDays size={20} /> },
  { key: 'ranking', label: 'Ranking',  match: (p) => p.startsWith('/move/ranking'),                                       to: '/move/ranking',  icon: <Trophy size={20} /> },
  { key: 'activity', label: 'Actividad', match: (p) => p.startsWith('/move/activity'),                                     to: '/move/activity', icon: <Activity size={20} /> },
  { key: 'human', label: 'Human', match: () => false, to: '/user', icon: <ArrowLeft size={20} />, back: true },
];

export default function MoveFooter() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <footer className={styles.footer}>
      {tabs.map((tab) => {
        const isActive = tab.match(pathname);
        const cls = [
          styles.tab,
          isActive ? styles.tabActive : '',
          isActive ? styles.tabPill : '',
          tab.back ? styles.tabBack : '',
        ].filter(Boolean).join(' ');
        return (
          <button key={tab.key} className={cls} onClick={() => navigate(tab.to)} type="button">
            <span className={styles.tabIconBox}>{tab.icon}</span>
            <span>{tab.label}</span>
          </button>
        );
      })}
    </footer>
  );
}
